interface PlaceholderPageProps {
  title: string;
}

export function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-4">{title}</h1>
      <div className="bg-white rounded-lg shadow-sm p-8 text-center">
        <p className="text-gray-500">このページは実装予定です</p>
      </div>
    </div>
  );
}
